module.exports = __webpack_public_path__ + "static/media/pp.9529c1cb.png";


//////////////////
// WEBPACK FOOTER
// ./public/pp.png
// module id = 182
// module chunks = 0